export default __webpack_public_path__ + "static/media/brief-2.f89b8fb2.webp";